import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import StyleFields from 'Event/auth/TextField/StyleFields'
import Title from 'lib/ui/ConfigPanel/Title'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'

export default function LastNameFieldConfig() {
  const saveTemplate = useSaveTemplate()
  const {signUp, login} = useTemplate()
  const v = useAttendeeVariables()
  const addTranslation = useAddTranslation()

  const save = (data: any) => {
    const label = replaceAtPath(
      data,
      'signUp.lastNameLabel',
      '{{sign_up_last_name_label}}',
    )
    saveTemplate({
      ...data,
      localization: addTranslation({
        sign_up_last_name_label: label ?? '',
      }),
    })
  }

  const {
    form: {register},
  } = useConfig()

  return (
    <Config title="Last Name Field" onSave={save}>
      <SettingsPanel>
        <Title>Last Name</Title>
        <TextField
          name="signUp.lastNameLabel"
          defaultValue={v(signUp.lastNameLabel)}
          label="Label"
          inputProps={{
            'aria-label': 'last name label',
            ref: register,
          }}
        />
      </SettingsPanel>
      <StylingPanel>
        <StyleFields templateKey="login.input" values={login.input} />
      </StylingPanel>
    </Config>
  )
}
